import { useCallback } from 'react';
import { AuctionType } from '#/unified-rfqs/entities/shared';
import { TradeTapeItem as DrfqTradeTapeItem } from '../../entities/drfq/trades';
import { DrfqPayload, useMarketPayloadCreator } from './shared';

export default function useCreateMarketFromRfqTrade() {
  const createPayload = useMarketPayloadCreator();
  const cb = useCallback(
    (trade: DrfqTradeTapeItem, auctionType: AuctionType = 'OB') => {
      return createPayload(transformRfqTradeToPayload(trade), auctionType);
    },
    [createPayload],
  );
  return cb;
}

export function transformRfqTradeToPayload(
  trade: DrfqTradeTapeItem,
): DrfqPayload {
  return {
    type: 'drfq',
    description: trade.description,
    counterparties: [],
    venue: trade.venue,
    role: 'MAKER',
    product_codes: trade.legs.map((leg) => leg.product_code),
    legs: trade.legs,
  };
}
